import React, { useContext, useRef } from 'react';

import { Context } from '@store/store';
import useClickOutside from '@utils/useClickOutside';

import {
  StyledThumbnailsSidebar,
  StyledThumbnail,
} from './thumbnails-sidebar.styles';

import { LazyImage } from './lazy-image';

const ThumbnailsSidebar = ({ thumbnails }) => {
  const [state, dispatch] = useContext(Context);
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, 'sidebar');

  return (
    <StyledThumbnailsSidebar
      isOpened={state.isThumbnailsSidebarOpened}
      data-is-opened={state.isThumbnailsSidebarOpened}
      sidebarWidth={state.sidebarWidth}
      ref={wrapperRef}
    >
      {thumbnails.map((thumbnail, index) => {
        const page = state.isSinglePageMode
        ? index
        : index >= state.pagesCount - 1
          ? state.pagesCount - 1
          : (Math.ceil((index) / 2) * 2);
        return (
          <Thumbnail
            key={index}
            src={thumbnail}
            page={index}
            onClick={() => {
              dispatch({
                type: 'SET_CURRENT_PAGE',
                payload: index,
              });
            }}
            active={ state.currentPage === page }
          />
        );
      })}
    </StyledThumbnailsSidebar>
  );
};

const Thumbnail = ({ src, onClick, active, page }) => {
  return (
    <StyledThumbnail onClick={onClick} active={active}>
      <LazyImage src={src} alt={`Эскиз страницы номер ${page + 1}`} />
      <span>{page + 1}</span>
    </StyledThumbnail>
  );
};

export default ThumbnailsSidebar;
